"use client"
import {
  Select
} from "./chunk-RFLHYWNR.mjs";

// src/components/multi-select.ts
import { mergeMultiStyle } from "@yamada-ui/core";
var MultiSelect = mergeMultiStyle(
  Select,
  {
    baseStyle: {
      clearIcon: {
        pointerEvents: "auto",
        transitionDuration: "normal",
        transitionProperty: "common",
        _disabled: {
          opacity: 0.4,
          pointerEvents: "none"
        },
        _focusVisible: {
          boxShadow: "outline"
        },
        _hover: {
          opacity: 0.8
        },
        _readOnly: {
          pointerEvents: "none"
        }
      }
    }
  }
)();

export {
  MultiSelect
};
//# sourceMappingURL=chunk-2ICYBDUT.mjs.map